<div
  mat-dialog-title
  appDraggableDialog
  draggableKey="change-tags"
  [draggableWithRestrictArea]="true"
  dialogClass=".q9-change-tags">
  <span>{{ 'STICKER.TAG_LABEL' | translate }}</span>
</div>

<mat-dialog-content>
  <q9-tags-select [formControl]="tags"></q9-tags-select>
</mat-dialog-content>
